var swiper = new Swiper(".motivos-slide", {
  slidesPerView: 2,
  spaceBetween: 0,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".motivos .swiper-button-next",
    prevEl: ".motivos .swiper-button-prev",
  },
  breakpoints: {
    1024: {
      slidesPerView: 6,
      spaceBetween: 0,
    }
  }
});

var swiper = new Swiper(".slideshow-init", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".slideshow-init .swiper-button-next",
    prevEl: ".slideshow-init .swiper-button-prev",
  },
  breakpoints: {
    1024: {
      slidesPerView: 1,
      spaceBetween: 0,
    }
  }
});